/**
 * Created by Carsten Bühler
 * User: c.buehler on 09.06.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';

import { ButtonGroup, DropdownButton, Dropdown } from 'external/react-bootstrap';
import { translation } from 'plugin/liferay-widgets-react-web';

const LayerConfigActionButtons = ({ onClickEdit, onClickDelete }) => {
    return (
        <ButtonGroup className="btnSettings">
            <DropdownButton
                variant="primary"
                id="layer-config-action-buttons"
                title={<span><i className="fa fa-wrench"/>{translation.trans('settings')}</span>}
            >
                {
                    onClickEdit &&
                    <Dropdown.Item variant="primary" onClick={onClickEdit.bind(this)}>
                        {translation.trans('edit')}
                    </Dropdown.Item>
                }
                {' '}
                {
                    onClickDelete &&
                    <Dropdown.Item variant="primary" onClick={onClickDelete.bind(this)}>
                        {translation.trans('delete')}
                    </Dropdown.Item>
                }

            </DropdownButton>
        </ButtonGroup>
    );
};

LayerConfigActionButtons.propTypes = {
    onClickEdit: PropTypes.func,
    onClickDelete: PropTypes.func
};

export default LayerConfigActionButtons;



// WEBPACK FOOTER //
// ./js/components/LayerConfigActionButtons.jsx